module.exports = __webpack_public_path__ + "img/yw_ysgh.6be1bb9a.svg";